import * as signalR from "@microsoft/signalr";

export enum SignalRConnectionStatus {
    Disconnected,
    Connected,
    Reconnecting,
}
export type TSignalRAction = "status" | "new-event" | "update-user-param";
export type TSignalREventAction =
    | "complaint-update"
    | "news-important-count"
    | "news-important-add"
    | "complaint-protest-update"
    | "complaint-additional-comments-update"
    | "check-qc-check-list"
    | "db-update"
    | "user-access-features"
    | "unread-messages-count"
    | "sd-claim-visited"
    | "sd-claim-not-visited"
    | "site-banners-updated"
    | "sd-my-claim-visited"
    | "sd-my-claim-not-visited"
    | "modal-alert"
    | "journal-count";

export type TSignalROnChangeFunction = (action: TSignalRAction, payload?: any) => void;

export class SignalRService {
    private connection: any = null;
    private connectionStart: boolean = false;
    private connectStatus: SignalRConnectionStatus = SignalRConnectionStatus.Disconnected;
    private reconnectTimeout = 10000;
    private onChangeFunction: TSignalROnChangeFunction | null = null;

    start(url: string, cb: TSignalROnChangeFunction) {
        const options: signalR.IHttpConnectionOptions = { withCredentials: false };

        this.onChangeFunction = cb;
        this.connectionStart = true;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(url, options)
            .withAutomaticReconnect([0, 3000, 5000, 10000])
            .build();
        this.connection.onclose(() => {
            this.setConnectStatus(SignalRConnectionStatus.Disconnected);
            this.reconnect();
        });
        this.connection.onreconnecting(() => {
            this.setConnectStatus(SignalRConnectionStatus.Disconnected);
        });
        this.connection.onreconnected(() => {
            this.setConnectStatus(SignalRConnectionStatus.Connected);
        });

        this.connection.on("new-event", (action: string, payload: any) => {
            this.setEvent("new-event", { action, payload });
        });
        this.connection.on("update-user-param", (action: string, payload: any) => {
            this.setEvent("update-user-param", { action, payload });
        });

        this.connection
            .start()
            .then(() => {
                this.setConnectStatus(SignalRConnectionStatus.Connected);
            })
            .catch((e: any) => {
                this.reconnect();
            });
    }
    setEvent(action: TSignalRAction, payload: any = null) {
        if (!!this.onChangeFunction) {
            this.onChangeFunction(action, payload);
        }
    }
    stop() {
        if (!!this.connection) {
            this.connectionStart = false;
            if (!!this.connection) {
                this.connection.stop();
                this.setConnectStatus(SignalRConnectionStatus.Disconnected);
                this.connection = null;
                this.onChangeFunction = null;
            }
        }
    }
    reconnect() {
        if (this.connectionStart) {
            this.setConnectStatus(SignalRConnectionStatus.Reconnecting);
            setTimeout(() => {
                this.connection
                    .start()
                    .then(() => {
                        this.setConnectStatus(SignalRConnectionStatus.Connected);
                    })
                    .catch(() => this.reconnect());
            }, this.reconnectTimeout);
        }
    }
    setConnectStatus(newStatus: SignalRConnectionStatus) {
        if (this.connectStatus !== newStatus) {
            this.connectStatus = newStatus;
            this.setEvent("status", this.connectStatus);
        }
    }
}
